'use client';

import { EvType } from '@/lib/actions/usage/constants';
import { atomWithStorage } from 'jotai/utils';

export const getOnInitTrue = { getOnInit: true };

export const basicInfoExpandAtom = atomWithStorage<boolean>(
    'basicInfoExpand',
    false,
    undefined,
    getOnInitTrue
);
export const flexAtom = atomWithStorage<boolean>(
    'flex',
    false,
    undefined,
    getOnInitTrue
);
export const baseUsageAtom = atomWithStorage<string>(
    'baseUsage',
    '',
    undefined,
    getOnInitTrue
);
export const zipCodeAtom = atomWithStorage<string>(
    'zipCode',
    '',
    undefined,
    getOnInitTrue
);
export const yearBuiltAtom = atomWithStorage<string>(
    'yearBuilt',
    '',
    undefined,
    getOnInitTrue
);
export const sqftAtom = atomWithStorage<string>(
    'sqft',
    '',
    undefined,
    getOnInitTrue
);
export const storiesAtom = atomWithStorage<string>(
    'stories',
    '',
    undefined,
    getOnInitTrue
);
export const hhSizeAtom = atomWithStorage<string>(
    'hhSize',
    '',
    undefined,
    getOnInitTrue
);
export const utilityCoAtom = atomWithStorage<string>(
    'utilityCo',
    '',
    undefined,
    getOnInitTrue
);

export type Ev = {
    type: EvType | undefined;
    milesPerYear: string;
    homeChgPct: string;
};

export const addEvExpandAtom = atomWithStorage<boolean>(
    'addEvExpand',
    false,
    undefined,
    getOnInitTrue
);
export const numEvsAtom = atomWithStorage<number>(
    'numEvs',
    0,
    undefined,
    getOnInitTrue
);
export const evsAtom = atomWithStorage<Ev[]>(
    'evs',
    [],
    undefined,
    getOnInitTrue
);

export const changeAddPeopleAtom = atomWithStorage<boolean>(
    'changeAddPeople',
    false,
    undefined,
    getOnInitTrue
);
export const addPeopleAtom = atomWithStorage<string>(
    'addPeople',
    '',
    undefined,
    getOnInitTrue
);

export const addHvacUseAtom = atomWithStorage<boolean>(
    'addHvacUse',
    false,
    undefined,
    getOnInitTrue
);

export const moreDetailsExpandAtom = atomWithStorage<boolean>(
    'moreDetailsExpand',
    false,
    undefined,
    getOnInitTrue
);
export const electricHeatAtom = atomWithStorage<boolean>(
    'electricHeat',
    false,
    undefined,
    getOnInitTrue
);
export const hasHeatPumpAtom = atomWithStorage<boolean>(
    'hasHeatPump',
    false,
    undefined,
    getOnInitTrue
);
export const hasElectricStoveAtom = atomWithStorage<boolean>(
    'hasElectricStove',
    false,
    undefined,
    getOnInitTrue
);
export const hasElectricWaterHeaterAtom = atomWithStorage<boolean>(
    'hasElectricWaterHeater',
    false,
    undefined,
    getOnInitTrue
);

export const hasAcAtom = atomWithStorage<boolean>(
    'hasAc',
    false,
    undefined,
    getOnInitTrue
);

export const openTargetOffsetModalAtom = atomWithStorage<boolean>(
    'openTargetOffsetModal',
    false,
    undefined,
    getOnInitTrue
);

export const openFlexCustomerModalAtom = atomWithStorage<boolean>(
    'openFlexCustomerModal',
    false,
    undefined,
    getOnInitTrue
);

export const addCleanHeatAndAcAtom = atomWithStorage<boolean>(
    'addCleanHeatAndAc',
    false,
    undefined,
    getOnInitTrue
);

export const addHeatPumpWaterHeaterAtom = atomWithStorage<boolean>(
    'addHeatPumpWaterHeater',
    false,
    undefined,
    getOnInitTrue
);

export const addInductionStoveAtom = atomWithStorage<boolean>(
    'addInductionStove',
    false,
    undefined,
    getOnInitTrue
);
